import React, { FC } from 'react'
import { Col, Container, Row, useScreenClass } from 'react-grid-system'
import { SectionTitle, ImageBlock, Button } from '../shared'
import styled from 'styled-components'
import MMAL from '../../assets/shows/MMAL.jpg'
import AllAmericanRuins from '../../assets/shows/AllAmericanRuins.jpg'
import SPESHFX from '../../assets/shows/SpeshFX.jpg'
import INTHY from '../../assets/shows/INTHY.jpg'

const Shows: FC = () => {
  const screenClass = useScreenClass()
  const isDesktop = ['lg', 'xl'].includes(screenClass)

  /* Was a 700px fixed height with 20rem of top padding pulled back up by a
     -285px margin. Auto height with ordinary padding does the same job. */
  const Section = styled.section`
    background-color: #ffffff;
    width: 100%;
    padding: ${isDesktop ? '4.25rem 0 4.75rem' : '2.5rem 0 3rem'};
  `

  // Now an <a> instead of a <div>, so only one navigation event
  const ClickableImageBlock = styled.a`
    display: block;
    transition: transform 0.3s ease, box-shadow 0.3s ease;
    cursor: pointer;
    border-radius: 8px;
    overflow: hidden;
    text-decoration: none; /* remove default underline */

    &:hover {
      transform: scale(1.05);
      box-shadow: 0 8px 20px rgba(0, 0, 0, 0.3);
    }
  `

  const imgStyles = {
    width: isDesktop ? undefined : '100%',
    margin: isDesktop ? undefined : '0 auto',
    display: 'block',
  }

  const shows = [
    {
      src: AllAmericanRuins,
      alt: 'All American Ruins Podcast Cover',
      link: 'https://www.blakepfeil.com/allamericanruins.html',
    },
    {
      src: MMAL,
      alt: 'My Most Authentic Life Podcast Cover',
      link: 'https://www.mymostauthenticlife.com/home',
    },
    {
      src: SPESHFX,
      alt: 'SpeshFX Podcast Cover',
      link: 'https://cms.megaphone.fm/channel/speshfx?selected=STONY7817442896',
    },
    {
      src: INTHY,
      alt: 'It’s Nice to Hear You Podcast Cover',
      link: 'https://www.itsnicetohearyou.com/',
    },
  ]

  return (
    <Section>
      <SectionTitle color="black" descr="Check out the shows that have been produced through our fellowship">
        Alumni Shows
      </SectionTitle>

      <Container style={{ marginTop: '2.5rem' }}>
        <Row>
          {shows.map(({ src, alt, link }, idx) => (
            <Col key={idx} xs={12} sm={12} md={6} lg={3}>
              <ClickableImageBlock
                href={link}
                target="_blank"
                rel="noopener noreferrer"
              >
                <ImageBlock
                  src={src}
                  alt={alt}
                  imgStyles={imgStyles}
                  // removed the `link` prop here so it doesn’t add its own <a>
                />
              </ClickableImageBlock>
            </Col>
          ))}
        </Row>

        <div style={{ textAlign: 'center', marginTop: '2.25rem' }}>
          <Button variant="red" path="/shows">
            More Shows
          </Button>
        </div>
      </Container>
    </Section>
  )
}

export default Shows
